




















import get from 'lodash/get';
import VTooltip from 'v-tooltip';
import { Component, Prop } from 'vue-property-decorator';
import { africaOptions, dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import { urlParam } from '../helpers/utils';
import Newsletter from '../models/Newsletter';
import BaseComponent from './Base';

@Component
export default class NewsletterForm extends BaseComponent {
    @Prop({ type: String, default: 'subscribe' }) protected readonly event: string;

    protected newsletter: Newsletter = new Newsletter(this.isSubscribe, this.isSubscribe ? { email: urlParam('email', undefined) } : {});

    protected terms: string | null = this.isSubscribe && africaOptions.newsletter.subscribeTerms ? africaOptions.newsletter.subscribeTerms : null;

    protected loading: boolean = false;

    protected showValidation: boolean = false;

    protected isMobileViewportSize: boolean = false;

    protected isTooltipEnabled: boolean = false;

    protected errors: Record<'name' | 'email' | 'confirm', string> = {
        name: '',
        email: '',
        confirm: '',
    };

    protected messagesPool: Array<{ message: string, class: string }> = [];

    protected confirm: boolean = false;

    protected get name(): string {
        return this.newsletter.name;
    }

    protected set name(name: string) {
        this.newsletter.name = name;
    }

    protected get email(): string {
        return this.newsletter.email;
    }

    protected set email(email: string) {
        this.newsletter.email = email;
    }

    protected tooltipOps(field: string): any {
        return {
            content: this.errors[field],
            container: this.$el,
            placement: 'left',
            classes: 'c-tooltip--error',
            show: !this.isMobileViewportSize && this.errors[field] !== '',
            trigger: 'manual',
            autoHide: false,
            hideOnTargetClick: false,
            offset: 5,
        };
    }

    protected validationClasses(field: string): { [key: string]: boolean } {
        return {
            'has-error': this.errors[field] !== '',
            'has-success': this.isMobileViewportSize && this.errors[field] === '',
        };
    }

    protected get isSubscribe(): boolean {
        return this.event === 'subscribe';
    }

    protected async onSubmit(): Promise<void> {
        this.messagesPool = [];
        this.showValidation = true;
        this.loading = true;

        const isValid: boolean = await this.validate();
        if (!isValid) {
            this.loading = false;

            return;
        }
        const response = await this.newsletter.save();
        const isSuccess: boolean = get(response, 'success') || false;
        const message: string = get(response, 'body') || '';

        this.messagesPool.push({ message, class: isSuccess ? 'has-success' : 'has-error' });
        this.loading = false;
        if (isSuccess) {
            this.addToDataLayer(this.newsletter.email);
            this.clear();
        }
    }

    protected clear(): void {
        this.name = '';
        this.email = '';
        this.confirm = false;
        this.showValidation = false;
        this.loading = false;
        this.errors = {
            name: '',
            email: '',
            confirm: '',
        };
    }

    protected async validate(): Promise<boolean> {
        const errors: { [key: string]: string } = {};
        try {
            if (this.terms && !this.confirm) {
                errors.confirm = this.t('We need your consent to send the newsletter.');
            }
            await this.newsletter.validate();
        } catch (err) {
            this.newsletter.collectErrors().forEach((collection) => {
                collection.path.forEach((elName) => {
                    errors[elName] = collection.errors.map(({ message }) => message).join('<br>');
                });
            });
        }
        this.errors = {
            name: '',
            email: '',
            confirm: '',
            ...errors,
        };

        return !Object.values(this.errors).some(Boolean);
    }

    protected onWindowResize(): void {
        this.isMobileViewportSize = window.innerWidth < 768;

        if (this.isTooltipEnabled && this.isMobileViewportSize) {
            this.isTooltipEnabled = false;
            VTooltip.enabled = false;
        }

        if (!this.isTooltipEnabled && !this.isMobileViewportSize) {
            this.isTooltipEnabled = true;
            VTooltip.enabled = true;
        }
    }

    protected async revalidate(): Promise<void> {
        if (!this.showValidation) {
            return;
        }
        await this.validate();
    }

    protected mounted(): void {
        VTooltip.enabled = false;
        this.$watch('newsletter', this.revalidate, { deep: true });
        this.$watch('confirm', this.revalidate);
        this.onWindowResize();
        EventBus.$on('windowResize', this.onWindowResize);
    }

    protected addToDataLayer(email: string): void {
      dataLayer.push({
        event: 'form_newsletter',
        form_email: email,
      });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewsletterForm.vue